// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__3QXR5","NavigationItemsContainer":"NavigationItems_NavigationItemsContainer__2ritD"};